import { callApiWithAuthorization } from "../CallApi";

export async function getOptimizedAttributes(componentType, attributes) {
    const request = await callApiWithAuthorization("/api/v0/alicegpt/attribute-table/optimize", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            componentType,
            attributes
        })
    })
    const response = await request.json();
    return response;
}

export async function getOptimizedFormBuilderAttributes(componentType, attributes) {
    const request = await callApiWithAuthorization("/api/v0/alicegpt/form-builder/optimize", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            componentType,
            attributes
        })
    })
    const response = await request.json();
    return response;
}